<template>
    <div class="entity-compare">
        <v-row class="entity-compare-header m-0">
            <v-col cols="6" class="header-col left"><h4>Before</h4></v-col>
            <v-col cols="6" class="header-col right"><h4>After</h4></v-col>
        </v-row>
        <v-row class="entity-compare-body m-0">
            <v-col cols="6" class="body-col left">
                <notification-pharmacy-sites-approval-request-form
                    :store="pharmacySites"
                    :is-afert="true"
                ></notification-pharmacy-sites-approval-request-form>
            </v-col>

            <v-col cols="6" class="body-col right">
                <notification-pharmacy-sites-approval-request-form
                    :store="pharmacySitesSnapShot"
                ></notification-pharmacy-sites-approval-request-form>
            </v-col>
        </v-row>
    </div>
</template>
<script>
export default {
    name: 'NotificationPharmacySitesApprovalRequest',
    components: {},
    props: {},
    data() {
        return {};
    },
    computed: {
        notification() {
            return this.$store.state.notifications.current;
        },
        pharmacySites() {
            return this.$store.state.notification_pharmacy_site.pharmacy_site;
        },
        pharmacySitesSnapShot() {
            return this.$store.state.notification_pharmacy_site.pharmacy_siteSnapShot;
        },
    },
    watch: {},
    created() {},
    methods: {},
};
</script>
